import { jsx as i, jsxs as j, Fragment as I } from "react/jsx-runtime";
import $, { useState as A, useId as T, useEffect as v, cloneElement as k } from "react";
import { c as f } from "../clsx-OuTLNxxd.js";
import { A as q, E as w } from "../index-Dlw4JYvo.js";
import '../Accordion.css';const R = "320px", U = "600px", L = "1025px", O = "_header_18xjb_33", D = "_splitHeader_18xjb_37", G = "_iconSlot_18xjb_43", J = "_heading_18xjb_50", K = "_toggle_18xjb_57", Q = "_triggerElement_18xjb_66", X = "_indicator_18xjb_69", Y = "_trigger_18xjb_66", Z = "_contentElement_18xjb_91", M = "_content_18xjb_91", V = "_primary_18xjb_111", C = "_secondary_18xjb_114", N = "_item_18xjb_120", ee = "_dense_18xjb_120", te = "_nav_18xjb_213", ne = "_link_18xjb_218", ie = "_headingText_18xjb_250", oe = "_linkLabel_18xjb_251", ce = "_linkList_18xjb_278", t = {
  mobile: R,
  "mobile-wide": "480px",
  tablet: U,
  "tablet-wide": "800px",
  desktop: L,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  header: O,
  splitHeader: D,
  iconSlot: G,
  heading: J,
  toggle: K,
  triggerElement: Q,
  indicator: X,
  trigger: Y,
  contentElement: Z,
  content: M,
  primary: V,
  secondary: C,
  item: N,
  dense: ee,
  nav: te,
  link: ne,
  headingText: ie,
  linkLabel: oe,
  linkList: ce
}, re = (r) => {
  if (typeof requestAnimationFrame != "function")
    return r(), () => {
    };
  let x = 0;
  const o = requestAnimationFrame(() => {
    x = requestAnimationFrame(r);
  });
  return () => {
    cancelAnimationFrame(o), cancelAnimationFrame(x);
  };
}, le = ({
  animationDurationMs: r = 0,
  indicatorSize: x = "s",
  isOpen: o,
  onChange: e,
  stroke: _ = "bold"
}) => {
  const [c, l] = A(o), s = r > 0, [u, h] = A(o), [z, y] = A(!!o), a = T(), m = T(), p = () => {
    e == null || e(!c), l(!c);
  };
  v(() => {
    o !== c && l(o);
  }, [o]), v(() => {
    if (!s) return;
    if (c)
      return h(!0), re(() => y(!0));
    y(!1);
    const n = setTimeout(() => h(!1), r);
    return () => clearTimeout(n);
  }, [c, s, r]);
  const b = {
    "aria-controls": m,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": c,
    "data-state": c ? "open" : "closed",
    id: a,
    onClick: p
  }, H = {
    "aria-labelledby": a,
    className: t.contentElement,
    hidden: s ? !u : !c,
    id: m,
    role: "region",
    ...s ? { "data-animated": "" } : {},
    ...s && z ? { "data-enter": "" } : {}
  };
  return {
    headingProps: b,
    sectionProps: H,
    triggerClass: t.triggerElement,
    Indicator: () => _ === "bold" ? /* @__PURE__ */ i(q, { className: t.indicator, size: x }) : /* @__PURE__ */ i(w, { className: t.indicator, size: x })
  };
}, ye = 300, de = ({
  animationDurationMs: r = 0,
  chevronStroke: x = "bold",
  children: o,
  classNames: e,
  heading: _,
  headingAs: c = "h3",
  icon: l,
  indicator: s,
  indicatorSize: u = "s",
  isDense: h = !1,
  isOpen: z = !1,
  links: y,
  onChange: a,
  onLinkClick: m,
  testId: p,
  toggleLabel: b,
  trackingAttribute: H,
  variant: n
}) => {
  const { Indicator: g, headingProps: d, sectionProps: E, triggerClass: W } = le({
    animationDurationMs: r,
    isOpen: z,
    onChange: a,
    indicatorSize: u,
    stroke: x
  }), B = {
    ...d,
    ...H ? { "data-analytics": H } : {},
    ...p ? { "data-testid": p } : {},
    type: "button"
  }, { id: F, ...P } = B;
  return /* @__PURE__ */ j(
    "div",
    {
      className: f(
        t.item,
        { [t.dense]: h },
        n && n !== "bare" && t[n],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ i(c, { className: f(t.header, { [t.splitHeader]: b }, e == null ? void 0 : e.header), children: b ? /* @__PURE__ */ j(I, { children: [
          /* @__PURE__ */ j("span", { className: f(t.heading, e == null ? void 0 : e.heading), id: F, children: [
            l !== void 0 && /* @__PURE__ */ i("span", { className: t.iconSlot, children: l }),
            _
          ] }),
          /* @__PURE__ */ i(
            "button",
            {
              "aria-label": b,
              className: f(W, t.toggle, e == null ? void 0 : e.button),
              ...P,
              children: s ?? /* @__PURE__ */ i(g, {})
            }
          )
        ] }) : /* @__PURE__ */ j("button", { className: f(W, t.trigger, e == null ? void 0 : e.button), ...B, children: [
          l === void 0 ? _ : /* @__PURE__ */ j(I, { children: [
            /* @__PURE__ */ i("span", { className: t.iconSlot, children: l }),
            /* @__PURE__ */ i("span", { className: f(t.headingText, e == null ? void 0 : e.heading), children: _ })
          ] }),
          s ?? /* @__PURE__ */ i(g, {})
        ] }) }),
        /* @__PURE__ */ i(
          "div",
          {
            ...E,
            className: f(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${r}ms` },
            children: y ? /* @__PURE__ */ i("ul", { className: t.linkList, children: y.map((S) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ j("a", { className: t.link, href: S.href, onClick: () => m == null ? void 0 : m(S), children: [
              /* @__PURE__ */ i("span", { className: t.iconSlot, children: S.icon }),
              /* @__PURE__ */ i("span", { className: t.linkLabel, children: S.label })
            ] }) }, `${S.href}-${S.label}`)) }) : o
          }
        )
      ]
    }
  );
}, xe = ({
  chevronStroke: r = "bold",
  children: x,
  defaultOpen: o,
  indicatorSize: e = "s",
  isDense: _ = !1,
  name: c,
  onValueChange: l,
  type: s = "single",
  value: u,
  variant: h = "primary"
}) => {
  const z = s === "multiple", y = u !== void 0, a = $.Children.toArray(x), m = o ? a.map(() => !0) : a.map((n) => !!n.props.isOpen), [p, b] = A(m), H = (n, g) => {
    let d = [];
    z ? (d = [...p], d[g] = n) : (d = a.map(() => !1), n === !0 && (d[g] = !0)), b(d);
  };
  return /* @__PURE__ */ i(
    "div",
    {
      className: f(t.accordion, h !== "bare" && t[h]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: x && a.map(
        (n, g) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          k(n, {
            chevronStroke: r,
            indicatorSize: e,
            isDense: _,
            variant: h,
            isOpen: y ? n.props.value === u : p[g],
            key: `${c}-item-${g}`,
            onChange: (d) => {
              var E, W;
              (W = (E = n.props).onChange) == null || W.call(E, d), y ? l == null || l(d ? n.props.value ?? null : null) : H(d, g);
            }
          })
        )
      )
    }
  );
};
xe.Item = de;
export {
  ye as ACCORDION_FADE_DURATION_MS,
  xe as Accordion,
  le as useToggle
};
